/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import AnimationInstanceBase from './AnimationInstanceBase';

export default class SpineAnimationInstance extends AnimationInstanceBase<sp.Skeleton>
{
    public Play(): Promise<any>
    {
        return new Promise<any>((resolve, reject) =>
            {
                if (!this.options.AnimationName) { reject(new Error('No animation name configured.')); }

                try
                {
                    this.animation.setAnimation(0, this.options.AnimationName, this.options.Loop);
                    this.animation.timeScale = this.options.Speed * this.dtMod;

                    if (!this.options.Loop)
                    {
                        this.animation.setCompleteListener(() => resolve(true));
                    }
                    else
                    {
                        this.animation.node.once(AnimationInstanceBase.StoppedEvent, () => resolve(true));
                    }
                }
                catch (error)
                {
                    reject(error);
                }
            });
    }

    public Stop(): SpineAnimationInstance
    {
        if (this.hasDefaultAnimation())
        {
            this.animation.addAnimation(0, this.options.DefaultAnimation, this.options.Loop);
        }
        else
        {
            this.animation.clearTracks();
            this.animation.setToSetupPose();
            this.animation.updateWorldTransform();
        }

        this.emitStopped();
        return this;
    }
}
